/**
 * URL parsing utility for org-scoped routes.
 *
 * Extracts orgId and page path from URLs like:
 * - /42/dashboard → { orgId: 42, pagePath: 'dashboard' }
 * - /42/ → { orgId: 42, pagePath: '' }
 * - /42/crm/contacts → { orgId: 42, pagePath: 'crm/contacts' }
 */

/**
 * Parse an org-scoped route pathname.
 *
 * @param pathname - URL pathname (e.g., window.location.pathname)
 * @returns Parsed route or null if not an org route
 */
export function parseOrgRoute(
  pathname: string
): { orgId: number; pagePath: string } | null {
  // Match pathnames starting with /<number>/ or /<number> (end of string)
  const match = pathname.match(/^\/(\d+)(\/.*)?$/);

  if (!match) {
    return null;
  }

  // match[1] is guaranteed to be digits-only by the \d+ regex
  const orgId = parseInt(match[1], 10);
  // Remove leading slash and all trailing slashes to normalize for registry matching
  const pagePath = (match[2] || '').replace(/^\//, '').replace(/\/+$/, '');

  return { orgId, pagePath };
}
